var _circle, _path, _circle2, _path2, _circle3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 45,
    viewBox: "0 0 66 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 7,
    fill: "var(--icon-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8082 22.0259C25.7895 22.2059 19 22.0259 19 43.9999H47C47 22.0259 39.827 21.8459 32.8082 22.0259Z",
    fill: "var(--icon-color)",
    stroke: "var(--icon-color)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 7,
    r: 7,
    fill: "var(--icon-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8082 17.0259C36.5001 17.0259 52.5001 17.0259 52.5 38.9999H65C65 17.0259 57.8293 17.0259 50.8082 17.0259Z",
    fill: "var(--icon-color)",
    stroke: "var(--icon-color)",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "matrix(-1 0 0 1 23 0)",
    fill: "var(--icon-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1918 17.0259C29.4999 17.0259 13.4999 17.0259 13.5 38.9999H0.999981C0.999981 17.0259 8.17069 17.0259 15.1918 17.0259Z",
    fill: "var(--icon-color)",
    stroke: "var(--icon-color)",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.0e2955550fed357c6b1fbe5d7df13265.svg";
export { ForwardRef as ReactComponent };